module.exports = __webpack_public_path__ + "static/media/myrmeleotettix_maculatus.c28ae916.jpg";